import {
  Component,
  OnInit,
  Input,
  forwardRef,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  Validators,
  AbstractControl,
  ValidationErrors,
  FormGroup,
  UntypedFormControl,
} from '@angular/forms';

import { CONSTANTS_FORMS as CONST } from '../../mo-forms.constant';

@Component({
  selector: 'form-input-email',
  templateUrl: './input-email.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputEmailComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => InputEmailComponent),
      multi: true,
    },
  ],
})
export class InputEmailComponent implements OnInit, ControlValueAccessor, Validators {
  @Input() placeholder: string = '';
  @Input() label: string = '';
  @Input() required = true;
  @Input() disabled: boolean = false;
  @Input() iconCheck: boolean = false;
  @Input() iconBlock: boolean = false;
  @Input() hasError: boolean;
  @ViewChild('email') emailRef: UntypedFormControl;

  public value: any;
  public regexEmail: RegExp;
  public regexEmailInput: RegExp;

  private _onChange = (_: any) => {};
  private _onTouch = () => {};

  constructor() {
    this.value = '';
    this.regexEmail = CONST.REGEX.EMAIL;
    this.regexEmailInput = CONST.REGEX.EMAIL_INPUT;
  }

  ngOnInit() {}

  onChange() {
    this._onTouch();
    this._onChange(this.value);
  }

  writeValue(value: any): void {
    this.value = value ? value + '' : '';
  }

  registerOnChange(fn: any): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouch = fn;
  }

  validate(_: any): ValidationErrors | null {
    if (this.emailRef && this.emailRef.errors) {
      return this.emailRef.errors.regex
        ? { email: CONST.MESSAGES.ERROR_EMAIL_INVALID }
        : this.emailRef.errors;
    }
    return null;
  }
}
